import api from './api';

export async function getPortionSuppliesByStand(mobileStandId) {
  const { data } = await api.get(`/portion-supply/mobile-stand/${mobileStandId}`);
  return data;
}

export async function getPortionSupplyById(id) {
  const { data } = await api.get(`/portion-supply/${id}`);
  return data;
}

export async function createPortionSupply(payload) {
  const { data } = await api.post('/portion-supply', payload);
  return data;
}

export async function changeStatePortionSupply(id) {
  const { data } = await api.get(`/portion-supply/change-state/${id}`);
  return data;
}

export async function deletePortionSupply(id) {
  const { data } = await api.delete(`/portion-supply/${id}`);
  return data;
}
